import { gql } from '../../../__generated__/graphql/catalog'

/**
 * Cart embroidery upsell: lazily fetch the full embroidery configuration for a
 * cart line (by SKU) to help populate the Embroidery modal from cart.
 *
 * Shares the variant/group core selection with `FETCH_CART_VARIANTS` via
 * `...CartVariantCoreFields`; only the `...EmbroideryGroup` sub-tree and
 * `color.hexCodes` are genuinely specific to the upsell.
 */
export const FETCH_CART_EMBROIDERY_CONFIG = gql(`
  query GetCartEmbroideryConfig($sku: String!) {
    productCatalogVariants(skus: [$sku]) {
      ...CartVariantCoreFields
      group {
        ...EmbroideryGroup
        color {
          hexCodes
        }
      }
    }
  }
`)
